module.exports = {"pageTitleText":"OWASP Rules","ruleName":"RuleName","owaspThresholdLimit":"Owasp Threshold Limit","owaspParanoiaLevel":"Owasp Paranoia Level","owaspDetectRules":"Owasp DetectRules"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/owasp.json
// module id = CeaI
// module chunks = 3